/* eslint-disable no-nested-ternary */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import { IoDocumentText } from "react-icons/io5";
import { useHistory } from "react-router-dom";

import ClickableTooltip from "../../common/ClickableTooltip";
import PtoRequestDayList from "../PtoRequestPage/PtoRequestDayList";
import Badge from "../../common/Badge";
import { validateAuthRoles } from "../../../helpers";
import { formatDate, isSameOrAfter } from "../../../helpers/date";

const PtoApprovalItem = ({
  request: data,
  auth,
  handleUpdate,
  handleOpenModal,
  statusCodes
  // ptoData
}) => {
  const [request, setRequest] = useState({ ...data });
  const [hasChanges, setHasChanges] = useState(false);

  const history = useHistory();

  const handleSave = (req) => {
    handleUpdate(req);
    setHasChanges(false);
  };

  const handleInitialApproval = () => {
    const value = !request.initial_approval_on;
    const req = { ...request };

    req.status = statusCodes.find(
      (code) =>
        code.entity === "PTO Request" &&
        code.field === "status" &&
        code.order === (value ? 3 : 1)
    );

    if (value) {
      req.initial_approval_by = {
        _id: auth.user._id,
        full_name: auth.user.full_name
      };
      req.initial_approval_on = new Date();
    } else {
      req.initial_approval_by = null;
      req.initial_approval_on = null;
    }
    setRequest(req);
    handleSave(req);
  };

  const handleEditReservedPTO = () => {
    history.push(`/app/pto/${request._id}`);
  };

  const handleDecline = () => {
    const value = !request.declined_on;
    const req = { ...request };
    // find new status
    let newStatusOrder = 5;
    if (!value) {
      newStatusOrder = 1;
    }
    req.status = statusCodes.find(
      (code) =>
        code.entity === "PTO Request" &&
        code.field === "status" &&
        code.order === newStatusOrder
    );

    if (value) {
      req.declined_by = {
        _id: auth.user._id,
        full_name: auth.user.full_name
      };
      req.declined_on = new Date();
      req.initial_approval_by = null;
      req.initial_approval_on = null;
    } else {
      req.declined_by = null;
      req.declined_on = null;
    }
    setRequest({ ...req });
    handleSave(req);
  };

  const handleChangeNote = (field, note) => {
    setHasChanges(true);
    setRequest({ ...request, [field]: note });
  };

  const {
    employee,
    duration,
    days,
    request_note,
    initial_approval_on,
    initial_approval_by,
    initial_approval_note,
    declined_on,
    declined_by,
    manager,
    status,
    reason,
    start_date
  } = request;
  return (
    <div className="ptoApprovalItem">
      <Row className="mainRow">
        <Col md={4}>
          <div>
            <b>
              {employee?.full_name} requested: {duration}{" "}
              {duration === 1 ? "day" : "days"}{" "}
              {reason?.label ? ` - ${reason.label}` : ""}
            </b>{" "}
            {request_note && (
              <ClickableTooltip
                custom
                id={request._id}
                isNightMode={!auth.isNightMode}
                place="top"
                tooltipContent={
                  <pre
                    style={{
                      background: "none",
                      border: "none",
                      padding: 10,
                      margin: "0px 0px 5px",
                      color: auth.isNightMode ? "black" : "white"
                    }}
                  >
                    {request_note}
                  </pre>
                }
              >
                <IoDocumentText style={{ color: "#50accb" }} />
              </ClickableTooltip>
            )}
          </div>
        </Col>
        <Col md={5}>
          <p style={{ marginBottom: "0px" }}>
            Yearly Completed:&nbsp;
            {`${
              request && request.ptoBalance && request.ptoBalance.yearly
                ? request.ptoBalance.yearly
                : "0.00"
            } day${request?.ptoBalance?.yearly === 1 ? "" : "s"}`}
            &nbsp;Reserved:&nbsp;
            {`${
              request && request.ptoBalance && request.ptoBalance.reserved
                ? request.ptoBalance.reserved
                : "0.00"
            } day${request?.ptoBalance?.reserved === 1 ? "" : "s"}`}
          </p>
        </Col>
        <Col md={3} style={{ textAlign: "end" }}>
          <Badge className="badge-big" color={status.color}>
            {status.label}
          </Badge>
          {status.label.toLowerCase() === "completed" &&
            isSameOrAfter(new Date(start_date), new Date("1/1/2024")) && (
              <button
                className="btn btn-cancel pto-approval-btn"
                onClick={() =>
                  handleOpenModal("declineCompletedPTOModal", data)
                }
              >
                Decline
              </button>
            )}
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <PtoRequestDayList data={days} editing={false} />
        </Col>
        <Col md={8} style={{ paddingLeft: 0 }}>
          {validateAuthRoles(auth, "Admin,HR,Manager") && (
            <Row className="inital-approval-row">
              <Col md={8}>
                {initial_approval_on && initial_approval_by ? (
                  <span>
                    {`${initial_approval_by.full_name} approved on ${formatDate(
                      initial_approval_on,
                      "MM/dd/yyyy"
                    )}`}
                  </span>
                ) : declined_on && declined_by ? (
                  <span>
                    {`${
                      declined_by.full_name
                    } cancelled/declined on ${formatDate(
                      declined_on,
                      "MM/dd/yyyy"
                    )}`}
                  </span>
                ) : (
                  <i>{manager && manager.full_name}, pending</i>
                )}
                <input
                  style={{
                    display: "inline-flex",
                    marginTop: "5px",
                    flexGrow: 1,
                    width: "100%",
                    color: auth.isNightMode ? "#fff" : "#aaa",
                    background: auth.isNightMode
                      ? "rgb(125 113 113 / 20%)"
                      : "#fff"
                  }}
                  type="text"
                  disabled={status && !(parseInt(status.order) === 1)}
                  value={initial_approval_note || ""}
                  onChange={(e) =>
                    handleChangeNote("initial_approval_note", e.target.value)
                  }
                />
              </Col>
              <Col md={4}>
                {status && parseInt(status.order) === 1 && (
                  <div className="button-container-row">
                    <button
                      className="btn btn-success pto-approval-btn"
                      onClick={handleInitialApproval}
                    >
                      {`${hasChanges ? "save and " : ""}approve`}
                    </button>
                    <button
                      className=" btn btn-warning pto-approval-btn"
                      onClick={handleDecline}
                    >
                      {`${hasChanges ? "save and " : ""}cancel/decline`}
                    </button>
                  </div>
                )}

                {status && parseInt(status.order) === 3 && (
                  <div className="button-container-row">
                    <button
                      className=" btn btn-cancel pto-approval-btn"
                      onClick={handleInitialApproval}
                    >
                      Unapprove
                    </button>
                    <button
                      className=" btn btn-warning pto-approval-btn"
                      onClick={handleEditReservedPTO}
                    >
                      Edit
                    </button>
                  </div>
                )}
                {status &&
                  parseInt(status.order) === 5 &&
                  isSameOrAfter(new Date(start_date), new Date("1/1/2024")) && (
                    <div className="button-container-row">
                      <button
                        className=" btn btn-cancel pto-approval-btn"
                        onClick={handleDecline}
                      >
                        Revert Decline
                      </button>
                    </div>
                  )}
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </div>
  );
};
PtoApprovalItem.propTypes = {
  request: PropTypes.object,
  auth: PropTypes.object,
  handleUpdate: PropTypes.func,
  statusCodes: PropTypes.array,
  handleOpenModal: PropTypes.func
  // ptoData: PropTypes.object
};

export default PtoApprovalItem;
